import { createStore } from "vuex";
import axios from "axios";
import { Toast } from "vant";
import useGetImage from "@/composiables/useGetImage";
import useAddVideoPoster from "@/composiables/useAddVideoPoster";

axios.defaults.withCredentials = true;
const tip = (msg) => {
  Toast({
    message: msg,
    duration: 1000,
    forbidClick: true,
  });
};

let baseURL = process.env.VUE_APP_BASE_URL;

console.log(baseURL);

export default createStore({
  state: {
    article: {
      model: {
        title: "",
        author: "",
        source: "",
        publicTime: "",
      },
      sourceSrc: "",
    },
    photos: [],
    unionId: "",
    nickName: "",
    content: "",
    user: {},
    jsBridgePackage: {},
  },
  mutations: {
    updateArticle(state, article) {
      state.article = article;
      state.content = article.content;
      state.photos = useGetImage(article.content);
      if (article.model.img) {
        state.article.content = useAddVideoPoster(
          article.content,
          article.model.img
        );
      }

      if (article.unionId) {
        state.unionId = article.unionId;
      }
      if (article.nickName) {
        state.nickName = article.nickName;
      }
      //获取富文本中的视频流
      // if (article.content) {
      //     // var r = /<source [^>]*src=['"]([^'"]+)[^>]*>/g;
      //     // var regExp = /<source [^>]*>/g;
      //   var sourceDev = String(article.content.match(/<source [^>]*>/g));
      //   console.log("sourceDev", sourceDev);
      //   var sourceSrc = String(sourceDev.match(/src=['"]([^'"])*/g)).replace(/src="/, "");
      //   article.sourceSrc = baseURL + sourceSrc;
      //   sessionStorage.setItem("sourceSrc", article.sourceSrc)
      //   console.log("sourceSrc", article.sourceSrc);
      // }
    },
  },
  actions: {
    getArticle({ commit }, articleId) {
      return new Promise((resolve) => {
        axios
          .get(baseURL + "/api/news-detail/normal/" + articleId)
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 0) {
                commit("updateArticle", data.data);
                resolve(data.data);
              } else {
                tip(data.error);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },

    getJump() {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/livepage/index")
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                resolve(data.data);
              } else {
                tip(data.error);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch(() => {
            tip("网络错误，请重试");
          });
      });
    },
    loginByWx({ commit }, code) {
      console.log(code);
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/wechatoath", {
            params: {
              code,
            },
          })
          .then((res) => {
            console.log("res==>", res);
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                data.wxInfo = JSON.stringify(data.data);
                data.nickName = data.data.nickName;
                sessionStorage.setItem("wxInfo", JSON.stringify(data.data));
                sessionStorage.setItem("nickName", data.data.nickname);
                resolve();
              } else {
                tip(data.msg);
              }
            }
          })
          .catch((err) => {
            console.log(err);
            tip("网络错误，请重试");
          });
      });
    },
    getZsplusJsBrigde() {
      return new Promise((resolve) => {
        axios
          .get("https://zsrbactivity.zsnews.cn/api/common/zsrbjsbrigeconfig")
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code === 1) {
                // updateJsBridgePackage(data.data);
                resolve(data.data);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          })
          .catch((err) => {
            alert(err);
            tip("网络错误，请重试");
          });
      });
    },
    loginByZsplus({ commit }, info) {
      console.log(info);
      return new Promise((resolve) => {
        axios
          .post("https://zsrbactivity.zsnews.cn/api/common/zsplusauth", {
            sessionToken: info.sessionToken,
            head: info.head,
            nickName: info.nickName,
            phone: info.phone,
            gender: info.gender,
          })
          .then((res) => {
            if (res.status === 200) {
              const data = res.data;
              if (data.code == 1) {
                // 存储中山+授权用户信息
                sessionStorage.setItem("zsplusInfo", JSON.stringify(data.data));
                const { aplus_queue } = window;
                aplus_queue.push({
                  action: "aplus.setMetaInfo",
                  arguments: ["_user_id", data.data.user_id],
                });
                // info.nickName info.head info.sessionToken info.gender info.phone
                resolve();
              } else if (data.code == 2) {
                //sessionToken过期,需要配合iOS端做统一处理
                tip(data.msg);
              } else {
                tip(data.msg);
              }
            } else {
              tip("网络错误，请重试");
            }
          });
      });
    },
  },
  modules: {},
});
